// Runtime config. Values come from Vite env vars at build/dev time.
//
// In dev: VITE_WORKER_URL defaults to http://localhost:8787 (wrangler dev).
// In prod: set VITE_WORKER_URL in .env.local OR in your hosting environment to the deployed Worker URL.

export const config = {
  workerUrl: import.meta.env.VITE_WORKER_URL ?? 'http://localhost:8787',
  appVersion: '2.0.0',
  isDev: import.meta.env.DEV,
} as const;
